import { lazy } from 'react';

import RenderRoutes from './components/renderRoutes/index';
import {
  BARBER_BOOKING_SLOT_ROUTE,
  BARBER_PROFILE_ROUTE,
  BARBER_PROFILE_REVIEW_ROUTE,
  INDEX_ROUTE,
  ACCOUNT_UPDATE_PASSWORD_ROUTE,
  BARBER_BOOKING_CALLOUT_ADDRESS_ROUTE,
  BARBER_BOOKING_CONFIRMATION_ROUTE,
  BARBER_WAITING_LIST_START_ROUTE,
  BARBER_WAITING_LIST_END_ROUTE,
  BARBER_WAITING_LIST_CONFIRMATION_ROUTE,
  BARBER_WAITING_LIST_SUCCESS_ROUTE,
  BARBER_BOOKING_SUCCESS_ROUTE,
  BARBER_REFERRER_ROUTE,
  MY_BOOKINGS_ROUTE,
  PAYMENT_METHODS_ROUTE,
  BARBER_BOOKING_PUBLIC_ROUTE,
  AUTH_ROUTE,
  AUTH_OTP_ROUTE,
  AUTH_ACCOUNT_DETAILS_ROUTE,
  AUTH_RESET_PASSWORD_ROUTE,
} from './appRoutes/routeConstants';

const IndexComponent = lazy(() => import('pages'));

// Auth components
const UnifiedAuthComponent = lazy(() => import('pages/auth'));
const AuthOTPComponent = lazy(() => import('pages/auth/otp'));
const AuthAccountDetailsComponent = lazy(() => import('pages/auth/accountDetails'));
const AuthResetPasswordComponent = lazy(() => import('pages/auth/resetPassword'));

const AccountUpdatePasswordComponent = lazy(() => import('pages/account/updatePassword'));

const BarberProfileComponent = lazy(() => import('pages/barber/profile'));
const BookingSuccessComponent = lazy(() => import('pages/booking/success'));
const BookingCallOutComponent = lazy(() => import('pages/booking/callout'));
const BookingSlotComponent = lazy(() => import('pages/booking/timeSelection'));
const BookingConfirmationComponent = lazy(() => import('pages/booking/confirmation'));
const WaitingListTimeComponent = lazy(() => import('pages/waitingList/time'));
const WaitingListComponentConfirmation = lazy(() => import('pages/waitingList/confirmation'));
const WaitingListSuccess = lazy(() => import('pages/waitingList/success'));

const ReferFriendComponent = lazy(() => import('components/refer'));
const MyBookingsComponent = lazy(() => import('pages/customer/myBookings'));
const PaymentMethodComponent = lazy(() => import('pages/customer/paymentMethods'));
const BarberPublicBooking = lazy(() => import('pages/public/booking'));

export const COMMON_ROUTES = [
  {
    exact: true,
    name: 'booking-slot',
    path: BARBER_BOOKING_SLOT_ROUTE,
    component: BookingSlotComponent,
  },
  {
    exact: true,
    name: 'barber-profile',
    path: BARBER_PROFILE_ROUTE,
    component: BarberProfileComponent,
  },
  {
    exact: true,
    name: 'barber-profile-review',
    path: BARBER_PROFILE_REVIEW_ROUTE,
    component: BarberProfileComponent,
  },
  {
    exact: true,
    name: 'booking-success',
    path: BARBER_BOOKING_SUCCESS_ROUTE,
    component: BookingSuccessComponent,
  },
  {
    exact: true,
    name: 'barber-public-booking',
    path: BARBER_BOOKING_PUBLIC_ROUTE,
    component: BarberPublicBooking,
  },
];

export const NON_LOGGED_IN_ROUTES = [
  {
    path: '/',
    name: 'index',
    component: RenderRoutes,
    routes: [
      {
        exact: true,
        name: 'index',
        path: INDEX_ROUTE,
        component: IndexComponent,
      },
      // Auth routes
      {
        exact: true,
        name: 'unified-auth',
        path: AUTH_ROUTE,
        component: UnifiedAuthComponent,
      },
      {
        exact: true,
        name: 'auth-otp',
        path: AUTH_OTP_ROUTE,
        component: AuthOTPComponent,
      },
      {
        exact: true,
        name: 'auth-account-details',
        path: AUTH_ACCOUNT_DETAILS_ROUTE,
        component: AuthAccountDetailsComponent,
      },
      {
        exact: true,
        name: 'auth-reset-password',
        path: AUTH_RESET_PASSWORD_ROUTE,
        component: AuthResetPasswordComponent,
      },
      ...COMMON_ROUTES,
    ],
  },
];

export const LOGGED_IN_ROUTES = [
  {
    path: '/',
    name: 'routes',
    component: RenderRoutes,
    routes: [
      {
        exact: true,
        name: 'index',
        path: INDEX_ROUTE,
        component: IndexComponent,
      },
      {
        exact: true,
        name: 'account-update-password',
        path: ACCOUNT_UPDATE_PASSWORD_ROUTE,
        component: AccountUpdatePasswordComponent,
      },
      // New unified auth routes (also available for logged-in users)
      {
        exact: true,
        name: 'unified-auth-logged-in',
        path: AUTH_ROUTE,
        component: UnifiedAuthComponent,
      },
      {
        exact: true,
        name: 'auth-otp-logged-in',
        path: AUTH_OTP_ROUTE,
        component: AuthOTPComponent,
      },
      {
        exact: true,
        name: 'auth-account-details-logged-in',
        path: AUTH_ACCOUNT_DETAILS_ROUTE,
        component: AuthAccountDetailsComponent,
      },
      {
        exact: true,
        name: 'auth-reset-password-logged-in',
        path: AUTH_RESET_PASSWORD_ROUTE,
        component: AuthResetPasswordComponent,
      },
      {
        exact: true,
        name: 'booking-callout',
        path: BARBER_BOOKING_CALLOUT_ADDRESS_ROUTE,
        component: BookingCallOutComponent,
      },
      {
        exact: true,
        name: 'booking-confirmation',
        path: BARBER_BOOKING_CONFIRMATION_ROUTE,
        component: BookingConfirmationComponent,
      },
      {
        exact: true,
        name: 'refer-friend',
        path: BARBER_REFERRER_ROUTE,
        component: ReferFriendComponent,
      },
      {
        exact: true,
        name: 'my-bookings',
        path: MY_BOOKINGS_ROUTE,
        component: MyBookingsComponent,
      },
      {
        exact: true,
        name: 'payment-methods',
        path: PAYMENT_METHODS_ROUTE,
        component: PaymentMethodComponent,
      },
      {
        exact: true,
        name: 'waiting-list-start-time',
        path: BARBER_WAITING_LIST_START_ROUTE,
        component: WaitingListTimeComponent,
      },
      {
        exact: true,
        name: 'waiting-list-end-time',
        path: BARBER_WAITING_LIST_END_ROUTE,
        component: WaitingListTimeComponent,
      },
      {
        exact: true,
        name: 'waiting-list-confirmation',
        path: BARBER_WAITING_LIST_CONFIRMATION_ROUTE,
        component: WaitingListComponentConfirmation,
      },
      {
        exact: true,
        name: 'waiting-list-success',
        path: BARBER_WAITING_LIST_SUCCESS_ROUTE,
        component: WaitingListSuccess,
      },
      ...COMMON_ROUTES,
    ],
  },
];
